/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_GetParticipantsDto } from '../models/PagedResultDto_GetParticipantsDto';
import type { Wealthlane_CustomerService_Dtos_Participant_EmployeeStatusDto } from '../models/Wealthlane_CustomerService_Dtos_Participant_EmployeeStatusDto';
import type { Wealthlane_CustomerService_Dtos_Participant_ExportParticipantDto } from '../models/Wealthlane_CustomerService_Dtos_Participant_ExportParticipantDto';
import type { Wealthlane_CustomerService_Dtos_Participant_GetParticipantDto } from '../models/Wealthlane_CustomerService_Dtos_Participant_GetParticipantDto';
import type { Wealthlane_CustomerService_Dtos_Participant_ImportBulkParticipantResponseDto } from '../models/Wealthlane_CustomerService_Dtos_Participant_ImportBulkParticipantResponseDto';
import type { Wealthlane_CustomerService_Dtos_Participant_ParticipantBulkExportDto } from '../models/Wealthlane_CustomerService_Dtos_Participant_ParticipantBulkExportDto';
import type { Wealthlane_CustomerService_Dtos_Participant_ParticipantBulkSendSignUpLinkResponseDto } from '../models/Wealthlane_CustomerService_Dtos_Participant_ParticipantBulkSendSignUpLinkResponseDto';
import type { Wealthlane_CustomerService_Dtos_Participant_ParticipantdAdminDto } from '../models/Wealthlane_CustomerService_Dtos_Participant_ParticipantdAdminDto';
import type { Wealthlane_CustomerService_Dtos_Participant_ParticipantDto } from '../models/Wealthlane_CustomerService_Dtos_Participant_ParticipantDto';
import type { Wealthlane_CustomerService_Dtos_Participant_ParticipantImportDto } from '../models/Wealthlane_CustomerService_Dtos_Participant_ParticipantImportDto';
import type { Wealthlane_CustomerService_Dtos_Participant_ParticipantStatusDto } from '../models/Wealthlane_CustomerService_Dtos_Participant_ParticipantStatusDto';
import type { Wealthlane_CustomerService_Dtos_Participant_RegistredParticipantDto } from '../models/Wealthlane_CustomerService_Dtos_Participant_RegistredParticipantDto';
import type { Wealthlane_CustomerService_Dtos_Participant_ResidentStatusDto } from '../models/Wealthlane_CustomerService_Dtos_Participant_ResidentStatusDto';
import type { Wealthlane_CustomerService_Dtos_Participant_SubmitParticipantForOnBoardingDto } from '../models/Wealthlane_CustomerService_Dtos_Participant_SubmitParticipantForOnBoardingDto';
import type { Wealthlane_CustomerService_Dtos_Participant_UpdateParticipantAddressDto } from '../models/Wealthlane_CustomerService_Dtos_Participant_UpdateParticipantAddressDto';
import type { Wealthlane_CustomerService_Dtos_Participant_UpdateParticipantDetailDto } from '../models/Wealthlane_CustomerService_Dtos_Participant_UpdateParticipantDetailDto';
import type { Wealthlane_CustomerService_Dtos_Participant_UpdateParticipantEmploymentDto } from '../models/Wealthlane_CustomerService_Dtos_Participant_UpdateParticipantEmploymentDto';
import type { Wealthlane_CustomerService_Dtos_Participant_UpdateParticipantTaxDto } from '../models/Wealthlane_CustomerService_Dtos_Participant_UpdateParticipantTaxDto';
import type { Wealthlane_CustomerService_Dtos_Participant_ViewParticipantAddressDto } from '../models/Wealthlane_CustomerService_Dtos_Participant_ViewParticipantAddressDto';
import type { Wealthlane_CustomerService_Dtos_Participant_ViewParticipantDto } from '../models/Wealthlane_CustomerService_Dtos_Participant_ViewParticipantDto';
import type { Wealthlane_CustomerService_Dtos_Participant_ViewParticipantEmploymentDto } from '../models/Wealthlane_CustomerService_Dtos_Participant_ViewParticipantEmploymentDto';
import type { Wealthlane_CustomerService_Dtos_Participant_ViewParticipantPersonalDetailDto } from '../models/Wealthlane_CustomerService_Dtos_Participant_ViewParticipantPersonalDetailDto';
import type { Wealthlane_CustomerService_Dtos_Participant_ViewParticipantTaxDto } from '../models/Wealthlane_CustomerService_Dtos_Participant_ViewParticipantTaxDto';
import type { Wealthlane_CustomerService_Dtos_ParticipantGovernmentDocument_GetGovernmentDocumentBlobRequest } from '../models/Wealthlane_CustomerService_Dtos_ParticipantGovernmentDocument_GetGovernmentDocumentBlobRequest';
import type { Wealthlane_CustomerService_Dtos_ParticipantGovernmentDocument_GovernmentDocumentBlobDto } from '../models/Wealthlane_CustomerService_Dtos_ParticipantGovernmentDocument_GovernmentDocumentBlobDto';
import type { Wealthlane_CustomerService_Dtos_ParticipantGovernmentDocument_GovernmentDocumentBlobRequest } from '../models/Wealthlane_CustomerService_Dtos_ParticipantGovernmentDocument_GovernmentDocumentBlobRequest';
import type { Wealthlane_CustomerService_Dtos_ParticipantSignUp_SendParticipantSignUpLinkVm } from '../models/Wealthlane_CustomerService_Dtos_ParticipantSignUp_SendParticipantSignUpLinkVm';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ParticipantService {

    /**
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_Participant_ParticipantImportDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppParticipantParticipants(
requestBody?: Array<Wealthlane_CustomerService_Dtos_Participant_ParticipantImportDto>,
): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_Participant_ParticipantImportDto>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/participant/participants',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param approvalStatusIds 
     * @param employeeType 
     * @param accountStatus 
     * @param isEmailSend 
     * @param brokerAccountStatusIds 
     * @param employeeStatus 
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_GetParticipantsDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantParticipantsList(
approvalStatusIds?: Array<number>,
employeeType?: string,
accountStatus?: string,
isEmailSend?: boolean,
brokerAccountStatusIds?: Array<number>,
employeeStatus?: string,
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_GetParticipantsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant/participants-list',
            query: {
                'ApprovalStatusIds': approvalStatusIds,
                'EmployeeType': employeeType,
                'AccountStatus': accountStatus,
                'IsEmailSend': isEmailSend,
                'BrokerAccountStatusIds': brokerAccountStatusIds,
                'EmployeeStatus': employeeStatus,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_Participant_ParticipantDto OK
     * @throws ApiError
     */
    public static putApiCustomerApiAppParticipantParticipant(
requestBody?: Wealthlane_CustomerService_Dtos_Participant_ParticipantDto,
): CancelablePromise<Wealthlane_CustomerService_Dtos_Participant_ParticipantDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/customer/api/app/participant/participant',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_CustomerService_Dtos_Participant_ViewParticipantDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantParticipantById(
id: string,
): CancelablePromise<Wealthlane_CustomerService_Dtos_Participant_ViewParticipantDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant/participant-by-id/{Id}',
            path: {
                'Id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_CustomerService_Dtos_Participant_ParticipantDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantUpdateParticipantById(
id: string,
): CancelablePromise<Wealthlane_CustomerService_Dtos_Participant_ParticipantDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant/update-participant-by-id/{Id}',
            path: {
                'Id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CustomerService_Dtos_Participant_ParticipantStatusDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantParticipantStatuses(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_Participant_ParticipantStatusDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant/participant-statuses',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CustomerService_Dtos_Participant_EmployeeStatusDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantParticipantEmployeeStatuses(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_Participant_EmployeeStatusDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant/participant-employee-statuses',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CustomerService_Dtos_Participant_ResidentStatusDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantResidentStatuses(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_Participant_ResidentStatusDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant/resident-statuses',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param name 
     * @param subject 
     * @param requestBody 
     * @returns boolean OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppParticipantSendEmail(
name?: string,
subject?: string,
requestBody?: Wealthlane_CustomerService_Dtos_Participant_ParticipantdAdminDto,
): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/participant/send-email',
            query: {
                'name': name,
                'subject': subject,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_Participant_ParticipantBulkSendSignUpLinkResponseDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppParticipantSendParticipantSignUpLink(
requestBody?: Wealthlane_CustomerService_Dtos_ParticipantSignUp_SendParticipantSignUpLinkVm,
): CancelablePromise<Wealthlane_CustomerService_Dtos_Participant_ParticipantBulkSendSignUpLinkResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/participant/send-participant-sign-up-link',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CustomerService_Dtos_Participant_ParticipantBulkExportDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppParticipantDownloadParticipantSample(): CancelablePromise<Wealthlane_CustomerService_Dtos_Participant_ParticipantBulkExportDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/participant/download-participant-sample',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_CustomerService_Dtos_Participant_ViewParticipantPersonalDetailDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantParticipantPersonalDetailById(
id: string,
): CancelablePromise<Wealthlane_CustomerService_Dtos_Participant_ViewParticipantPersonalDetailDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant/participant-personal-detail-by-id/{Id}',
            path: {
                'Id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_CustomerService_Dtos_Participant_ViewParticipantAddressDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantParticipantAddressById(
id: string,
): CancelablePromise<Wealthlane_CustomerService_Dtos_Participant_ViewParticipantAddressDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant/participant-address-by-id/{Id}',
            path: {
                'Id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_CustomerService_Dtos_Participant_ViewParticipantEmploymentDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantParticipantEmploymentById(
id: string,
): CancelablePromise<Wealthlane_CustomerService_Dtos_Participant_ViewParticipantEmploymentDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant/participant-employment-by-id/{Id}',
            path: {
                'Id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_CustomerService_Dtos_Participant_ViewParticipantTaxDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantParticipantTaxById(
id: string,
): CancelablePromise<Wealthlane_CustomerService_Dtos_Participant_ViewParticipantTaxDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant/participant-tax-by-id/{Id}',
            path: {
                'Id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_Participant_UpdateParticipantDetailDto OK
     * @throws ApiError
     */
    public static putApiCustomerApiAppParticipantParticipantDetails(
requestBody?: Wealthlane_CustomerService_Dtos_Participant_UpdateParticipantDetailDto,
): CancelablePromise<Wealthlane_CustomerService_Dtos_Participant_UpdateParticipantDetailDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/customer/api/app/participant/participant-details',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_Participant_UpdateParticipantAddressDto OK
     * @throws ApiError
     */
    public static putApiCustomerApiAppParticipantParticipantAddresses(
requestBody?: Wealthlane_CustomerService_Dtos_Participant_UpdateParticipantAddressDto,
): CancelablePromise<Wealthlane_CustomerService_Dtos_Participant_UpdateParticipantAddressDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/customer/api/app/participant/participant-addresses',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_Participant_UpdateParticipantEmploymentDto OK
     * @throws ApiError
     */
    public static putApiCustomerApiAppParticipantParticipantEmployment(
requestBody?: Wealthlane_CustomerService_Dtos_Participant_UpdateParticipantEmploymentDto,
): CancelablePromise<Wealthlane_CustomerService_Dtos_Participant_UpdateParticipantEmploymentDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/customer/api/app/participant/participant-employment',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_Participant_UpdateParticipantTaxDto OK
     * @throws ApiError
     */
    public static putApiCustomerApiAppParticipantParticipantTax(
requestBody?: Wealthlane_CustomerService_Dtos_Participant_UpdateParticipantTaxDto,
): CancelablePromise<Wealthlane_CustomerService_Dtos_Participant_UpdateParticipantTaxDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/customer/api/app/participant/participant-tax',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_Participant_SubmitParticipantForOnBoardingDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppParticipantSubmitParticipantForOnBoarding(
requestBody?: Wealthlane_CustomerService_Dtos_Participant_SubmitParticipantForOnBoardingDto,
): CancelablePromise<Wealthlane_CustomerService_Dtos_Participant_SubmitParticipantForOnBoardingDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/participant/submit-participant-for-on-boarding',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CustomerService_Dtos_Participant_RegistredParticipantDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantRegistredParticipants(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_Participant_RegistredParticipantDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant/registred-participants',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CustomerService_Dtos_Participant_RegistredParticipantDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantUnregisteredParticipants(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_Participant_RegistredParticipantDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant/unregistered-participants',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_ParticipantGovernmentDocument_GovernmentDocumentBlobDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppParticipantDownloadGovernmentDocument(
requestBody?: Wealthlane_CustomerService_Dtos_ParticipantGovernmentDocument_GetGovernmentDocumentBlobRequest,
): CancelablePromise<Wealthlane_CustomerService_Dtos_ParticipantGovernmentDocument_GovernmentDocumentBlobDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/participant/download-government-document',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_ParticipantGovernmentDocument_GovernmentDocumentBlobDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppParticipantDownloadGovernmentDocumentByParticipant(
requestBody?: Wealthlane_CustomerService_Dtos_ParticipantGovernmentDocument_GovernmentDocumentBlobRequest,
): CancelablePromise<Wealthlane_CustomerService_Dtos_ParticipantGovernmentDocument_GovernmentDocumentBlobDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/participant/download-government-document-by-participant',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param input 
     * @param participantId 
     * @returns Wealthlane_CustomerService_Dtos_Participant_GetParticipantDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantParticipantsForTax(
input?: string,
participantId?: string,
): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_Participant_GetParticipantDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant/participants-for-tax',
            query: {
                'input': input,
                'ParticipantId': participantId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CustomerService_Dtos_Participant_RegistredParticipantDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantTerminatedParticipants(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_Participant_RegistredParticipantDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant/terminated-participants',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CustomerService_Dtos_Participant_RegistredParticipantDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantRetirementEligibleParticipants(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_Participant_RegistredParticipantDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant/retirement-eligible-participants',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_CustomerService_Dtos_Participant_ImportBulkParticipantResponseDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantBulkImportStatus(
id: string,
): CancelablePromise<Wealthlane_CustomerService_Dtos_Participant_ImportBulkParticipantResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant/bulk-import-status/{Id}',
            path: {
                'Id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param sessionId 
     * @returns boolean OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppParticipantStopBulkImport(
sessionId: string,
): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/participant/stop-bulk-import/{sessionId}',
            path: {
                'sessionId': sessionId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_Participant_ParticipantBulkExportDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppParticipantExportParticipants(
requestBody?: Wealthlane_CustomerService_Dtos_Participant_ExportParticipantDto,
): CancelablePromise<Wealthlane_CustomerService_Dtos_Participant_ParticipantBulkExportDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/participant/export-participants',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData 
     * @returns Wealthlane_CustomerService_Dtos_Participant_ImportBulkParticipantResponseDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppParticipantImportBulkParticipants(
formData?: {
File?: Blob;
},
): CancelablePromise<Wealthlane_CustomerService_Dtos_Participant_ImportBulkParticipantResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/participant/import-bulk-participants',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param participantId 
     * @returns string OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantSocialSecurityNumberByParticipantId(
participantId: string,
): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant/social-security-number-by-participant-id/{ParticipantId}',
            path: {
                'ParticipantId': participantId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param participantId 
     * @returns string OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantDateOfBirthByParticipantId(
participantId: string,
): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant/date-of-birth-by-participant-id/{ParticipantId}',
            path: {
                'ParticipantId': participantId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_Participant_ParticipantBulkExportDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppParticipantExportParticipant(
requestBody?: Array<string>,
): CancelablePromise<Wealthlane_CustomerService_Dtos_Participant_ParticipantBulkExportDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/participant/export-participant',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
